import { Controller } from "stimulus"
import sjcl from '../src/sjcl.js';

export default class extends Controller {
  static targets = [ "encryptedContent", "decryptedContent", "password", "errorMessage" ]

  connect(){
    console.log(this.encryptedContentTarget.value)
    console.log(this.decryptedContentTarget.value)
    sjcl.random.startCollectors();
  }

  encrypt() {
    console.log("encrypt")
    // http://bitwiseshiftleft.github.io/sjcl/demo/
    let plaintext = this.decryptedContentTarget.value
    console.log(typeof this.passwordWithSalt())
    this.encryptedContentTarget.value = sjcl.encrypt(this.passwordWithSalt(), plaintext)
  }

  passwordWithSalt() {
    let password = this.passwordTarget.value
    let salt = "21DDA060 011F8832" // make random
    return salt+password
  }


  updatePassword(e){
    e.preventDefault()
    clearTimeout(this.typingTimer);

    this.typingTimer = setTimeout(() => {
      if(this.decryptedContentTarget.value.length !== 0)this.encrypt();
    else this.decrypt(e)
    }, 500);
  }

  decrypt(e) {
    e.preventDefault()
    console.log("decrypt")

    let ciphertext = this.encryptedContentTarget.value

    if (ciphertext.length === 0) { return; }
    if (this.passwordWithSalt().length === 0) { return; }

    try {
      this.decryptedContentTarget.innerHTML = sjcl.decrypt(this.passwordWithSalt(), ciphertext, {}).replace(/(?:\r\n|\r|\n)/g, '<br>');
      this.decryptedContentTarget.value = sjcl.decrypt(this.passwordWithSalt(), ciphertext, {});
      this.errorMessageTarget.innerHTML = ""
    } catch(e) {
      console.log("Can't decrypt: "+e);
      this.errorMessageTarget.innerHTML = "The password is wrong"
      this.decryptedContentTarget.innerHTML = this.decryptedContentTarget.value = ""
      return;
    }
  }

}
